/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Allocation_Form_Plan_Info_Per_MonthInputs */

const en_admin_allocation_form_plan_info_per_month = /** @type {(inputs: Admin_Allocation_Form_Plan_Info_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`month`)
};

const de_admin_allocation_form_plan_info_per_month = /** @type {(inputs: Admin_Allocation_Form_Plan_Info_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monat`)
};

const es_admin_allocation_form_plan_info_per_month = /** @type {(inputs: Admin_Allocation_Form_Plan_Info_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mes`)
};

const fr_admin_allocation_form_plan_info_per_month = /** @type {(inputs: Admin_Allocation_Form_Plan_Info_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mois`)
};

/** @type {(inputs: Admin_Allocation_Form_Plan_Info_Per_MonthInputs) => LocalizedString} */
const it_admin_allocation_form_plan_info_per_month = en_admin_allocation_form_plan_info_per_month;

/** @type {(inputs: Admin_Allocation_Form_Plan_Info_Per_MonthInputs) => LocalizedString} */
const pt_br2_admin_allocation_form_plan_info_per_month = en_admin_allocation_form_plan_info_per_month;

/** @type {(inputs: Admin_Allocation_Form_Plan_Info_Per_MonthInputs) => LocalizedString} */
const pl_admin_allocation_form_plan_info_per_month = en_admin_allocation_form_plan_info_per_month;

/** @type {(inputs: Admin_Allocation_Form_Plan_Info_Per_MonthInputs) => LocalizedString} */
const hu_admin_allocation_form_plan_info_per_month = en_admin_allocation_form_plan_info_per_month;

/** @type {(inputs: Admin_Allocation_Form_Plan_Info_Per_MonthInputs) => LocalizedString} */
const ro_admin_allocation_form_plan_info_per_month = en_admin_allocation_form_plan_info_per_month;

/**
* | output |
* | --- |
* | "month" |
*
* @param {Admin_Allocation_Form_Plan_Info_Per_MonthInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_allocation_form_plan_info_per_month = /** @type {((inputs?: Admin_Allocation_Form_Plan_Info_Per_MonthInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Allocation_Form_Plan_Info_Per_MonthInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_allocation_form_plan_info_per_month(inputs)
	if (locale === "de") return de_admin_allocation_form_plan_info_per_month(inputs)
	if (locale === "es") return es_admin_allocation_form_plan_info_per_month(inputs)
	if (locale === "fr") return fr_admin_allocation_form_plan_info_per_month(inputs)
	if (locale === "it") return it_admin_allocation_form_plan_info_per_month(inputs)
	if (locale === "pt-BR") return pt_br2_admin_allocation_form_plan_info_per_month(inputs)
	if (locale === "pl") return pl_admin_allocation_form_plan_info_per_month(inputs)
	if (locale === "hu") return hu_admin_allocation_form_plan_info_per_month(inputs)
	return ro_admin_allocation_form_plan_info_per_month(inputs)
});
export { admin_allocation_form_plan_info_per_month as "admin.allocation_form.plan_info_per_month" }